module.exports = __webpack_public_path__ + "components/modal-app-popup/static/firefox-icon-ddbf5b218b1f9a5e6fa65c4bd5a713bd.webp";